export default __webpack_public_path__ + "static/media/level-truck.0ca4794e.png";